module.exports = __webpack_public_path__ + "img/logo.72ced41.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo.png
// module id = Z2Ou
// module chunks = 4